import React from 'react';
import { motion } from 'framer-motion';
import { User } from 'lucide-react';
export function Lyudmila() {
  return <section className="py-24 bg-background" data-id="element-80">
      <div className="max-w-5xl mx-auto px-6" data-id="element-81">
        <div className="bg-surface rounded-[2.5rem] border border-border p-8 md:p-12 flex flex-col md:flex-row items-center gap-10 md:gap-16" data-id="element-82">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="w-full md:w-1/3 flex justify-center shrink-0" data-id="element-83">
            <div className="w-64 h-64 md:w-72 md:h-72 rounded-full overflow-hidden border-4 border-background shadow-xl bg-border flex items-center justify-center" data-id="element-84">
              <User size={120} className="text-secondary opacity-50" data-id="element-85" />
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="w-full md:w-2/3 flex flex-col text-center md:text-left" data-id="element-86">
            <h2 className="text-3xl md:text-4xl font-semibold mb-2" data-id="element-87">
              Вікторія
            </h2>
            <p className="text-primary font-medium mb-6" data-id="element-88">Бухгалтер для ФОП</p>

            <p className="text-secondary leading-relaxed mb-8 text-lg" data-id="element-89">
              Я допомагаю підприємцям вести бізнес без паперової тяганини і
              несподіваних штрафів. Знаю спрощену систему зсередини — усі форми
              оподаткування, нюанси звітності та типові помилки, яких легко
              уникнути. Відповідальність, конфіденційність і результат — це не
              просто слова.
            </p>

            <div className="flex flex-wrap justify-center md:justify-start gap-3" data-id="element-90">
              <span className="px-4 py-2 bg-background border border-border rounded-full text-sm font-medium text-primary" data-id="element-91">
                ФОП 1–3 група
              </span>
              <span className="px-4 py-2 bg-background border border-border rounded-full text-sm font-medium text-primary" data-id="element-92">
                Дистанційно
              </span>
              <span className="px-4 py-2 bg-background border border-border rounded-full text-sm font-medium text-primary" data-id="element-93">
                Вся Україна
              </span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}